import { useNavigate } from "react-router-dom";

/**
 * Custom hook to handle redirection within the app.
 * It supports both internal (React Router) and external (window.location) redirects.
 */
export const useRedirect = () => {
  const navigate = useNavigate();

  const redirectTo = (
    path: string,
    options?: { preserveHistory?: boolean },
  ) => {
    if (path.startsWith("http://") || path.startsWith("https://")) {
      if (options?.preserveHistory) {
        window.location.href = path;
      } else {
        window.location.replace(path);
      }
    } else {
      navigate(path, { replace: true });
    }
  };

  return redirectTo;
};
